module.exports = __webpack_public_path__ + "img/selected1-min.c60f037e.png";